import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  Col,
  Badge,
  Button,
  Modal,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Layers, Users, Mail, MessageSquare } from "react-feather";
import StaffTable from "./StaffTable";
import PopulationCard from "./PopulationCard";

const StaffManagementPage = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Helmet title="Staff Management" />
      <Container fluid className="p-0">
        <div className="d-flex mb-3 flex-row justify-content-between">
          <h1 className="h3 ">Staff Management</h1>
          <Button
            onClick={() => navigate("add-teacher")}
            variant="outline-primary"
          >
            New Staff
          </Button>
        </div>
        <Row className="equal-height-col">
          <Col md={4}>
            <PopulationCard />
          </Col>
          <Col md={4}>{/* <EnrollmentStatusCard /> */}</Col>
          <Col md={4}>{/* <SearchStudentCard /> */}</Col>
        </Row>
        <Row>
          <StaffTable />
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default StaffManagementPage;
